import { Checkbox as MaterialCheckbox, FormControlLabel } from "@mui/material";
import React from "react";

type CheckboxProps = {
    value: boolean;
    onChange: (value: boolean) => void;
    label?: string;
    description?: string;
    disabled?: boolean
};

export function Checkbox({ label, description, value, disabled, onChange }: CheckboxProps) {
    return (
      <div className="flex flex-col">
          <FormControlLabel
            label={label}
            slotProps={{
                typography: {
                    fontWeight: 700
                }
            }}
            control={
              <MaterialCheckbox
                checked={value}
                onChange={(_, checked) => onChange(checked)}
                disabled={disabled}
              />}
          />
          {description && <p className="mb-2">{description}</p>}
      </div>
    )
}
